import React from "react"

export const Settings = {
  primaryColor: "#195998",
  secondaryColor: "#ED2028",
  tertiaryColor: "#146DAF",
  greyColor: "#707070",
  sizeXL: "1440px",
  sizeL: "1024px",
  sizeM: "768px",
  sizeS: "568px",
  sizeXS: "360px",
}
